module.exports = __webpack_public_path__ + "static/media/educazione-finanziaria_incontri-individuali.d6ebd5c8.png";